'use client';

import { useTranslations } from 'next-intl';
import type { ComponentProps } from 'react';
import { Callout } from '../../Callout/Callout';
import { Summary, SummaryContent, SummaryItem } from '../../Summary/Summary';

type AutoRenewPanelProps = ComponentProps<'div'> & {
  activeSince: Date;
  onCancelClick: () => void;
  isJackpotHunt?: boolean;
};

function AutoRenewPanel({ className, activeSince, onCancelClick, isJackpotHunt = false, ...props }: AutoRenewPanelProps) {
  const translationKey = isJackpotHunt ? 'lotteries.ticket_details.jackpot_hunt_panel' : 'lotteries.ticket_details.auto_renew_panel';
  const t = useTranslations(translationKey);

  const panelTestId = isJackpotHunt ? 'jackpot-hunt-panel' : 'auto-renew-panel';
  const badgeTestId = isJackpotHunt ? 'jackpot-hunt-badge' : 'auto-renew-badge';
  const cancelLinkTestId = isJackpotHunt ? 'cancel-jackpot-hunt-link' : 'cancel-auto-renewal-link';

  return (
    <Summary className={className} {...props} data-testid={panelTestId}>
      <SummaryContent>
        <div className="mb-2">
          <Callout data-testid={badgeTestId}>{t('badge')}</Callout>
        </div>
        <SummaryItem label={t('active_since')} value={t('date_format', { date: activeSince })} data-testid="active-since" />
        <button
          type="button"
          onClick={onCancelClick}
          className="flex justify-items-start link-label-explanatory  text-foreground hover:text-foreground-hover underline outline-none focus-visible:border-ring focus-visible:ring-foreground focus-visible:ring-[3px] mt-4"
          data-testid={cancelLinkTestId}
          data-track-name={isJackpotHunt ? 'Jackpot Hunt' : 'Auto'}
        >
          {t('cancel_action')}
        </button>
      </SummaryContent>
    </Summary>
  );
}

export { AutoRenewPanel };
